var map = {
	"./bakery-min.png": "fdba",
	"./bakery.png": "0d1a",
	"./beverages-min.png": "02f1",
	"./beverages.png": "6175",
	"./bread-min.png": "c837",
	"./bread.png": "e710",
	"./dairy_all-min.png": "0fa9",
	"./dairy_all.png": "e65f",
	"./dairy_milk_only-min.png": "4c0a",
	"./dairy_milk_only.png": "21d9",
	"./meat-min.png": "4bf3",
	"./meat.png": "99c1",
	"./other-min.png": "e749",
	"./other.png": "d937",
	"./produce_all-min.png": "06b9",
	"./produce_all.png": "6675",
	"./produce_fruit_only-min.png": "2eab",
	"./produce_fruit_only.png": "cc2a",
	"./ready_meals-min.png": "8331",
	"./ready_meals.png": "1448",
	"./sandwiches-min.png": "83b0",
	"./sandwiches.png": "159f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "306e";